// Headless export registration for Polarity Scale (single-output custom SVG).
// The live leaf Chart is reused as-is; the Block-level derivation (calcChartData)
// is recreated here so the driver sends the raw question `answer`, mirroring the
// live dataflow (Block computes chartData → Chart draws). Key `psc` is the legacy
// pptx.coffee dispatch key (Option A). The report-param `psc{key}` decodes to
// mode (+ optional `!n{neutral}` suffix) — the driver forwards those as
// params.mode / params.neutral; defaults mirror legacy lib.coffee (pba / 0).
// Spec: .aidev/tasks/headless-charts-sdk-spike/docs/tasks/03b-nonhc-remainder.md §1

import {
  ExportableCharts,
  type ExportableChart
} from '@aytm/app/stats/page/question-views/components/charts/lib/exportable'

import { calcChartData } from '@aytm/app/stats/page/question-views/psc/lib/utils'

import PscChart from '@aytm/app/stats/page/question-views/psc/components/Chart'

const pscEntry: ExportableChart = {
  Component: PscChart,
  toProps: (data: any, params: any) => {
    const mode = params.mode || 'pba'
    const neutral = params.neutral ?? 0
    const degree = data.degree ?? 201

    const batches = data.batches || [] // JSON-string pole pairs are parsed downstream, in ChartRow and calcChartData

    return {
      id: data.id || data.questionKey,
      mode,
      batches,
      palette: data.palette || data.colorTheme,
      chartData: calcChartData({ answer: data.answer, batches, degree, neutral }),
      onExport: undefined
    }
  }
}

ExportableCharts.register('psc', pscEntry)
